import React, { FC } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Container, Label, Option, Select } from './Dropdown.styled';
import { isDropdownElement } from 'utils/typeGuards';
import { v4 as uuidv4 } from 'uuid';

const Dropdown: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isDropdownElement(currentElement)) {
    return null;
  }
  const { defaultOption, elements, labelText, required } = currentElement.content;
  return (
    <Container>
      <Label htmlFor={currentElement.id} style={{ color: required ? 'red' : '' }}>
        {labelText} {required && '*'}
      </Label>
      <Select>
        {elements.map(element => (
          <Option key={uuidv4()} value={element.value} selected={element.value === defaultOption}>
            {element.option}
          </Option>
        ))}
      </Select>
    </Container>
  );
};

export default Dropdown;
